export const getFirstIncompleteStep = (profile) => {
  // Handle null or undefined profile
  if (!profile) {
    return '/onboarding/child';
  }

  // If onboarding was fully completed (and not skipped), don't re-check individual fields
  if (profile.profileComplete && !profile.onboardingSkipped) {
    return '/home';
  }
  
  // If user previously skipped onboarding and we have a saved step, continue from there
  if (profile.onboardingSkipped && profile.lastOnboardingStep) {
    const stepRoutes = {
      1: '/onboarding/child',
      2: '/onboarding/location', 
      3: '/onboarding/challenges',
      4: '/onboarding/current-needs',
      5: '/onboarding/benefits'
    };
    return stepRoutes[profile.lastOnboardingStep] || '/onboarding/child';
  }
  
  
  // Check each step in sequence based on completed data
  if (!profile.child || !profile.child.birthYear) {
    return '/onboarding/child';
  }
  
  if (!profile.kommune || !profile.schoolStage) {
    return '/onboarding/location';
  }
  
  if (!profile.challenges || !profile.challenges.length) {
    return '/onboarding/challenges';
  }
  
  // Check if current needs step is complete (optional fields, so check if any data exists or if explicitly visited)
  const hasCurrentNeedsData = profile.currentStruggles || profile.familyGoals || 
                               profile.needsIntensiveSupport || profile.needsNightWatch || 
                               profile.needsContinuousSupervision || profile.currentNeedsVisited;
  if (!hasCurrentNeedsData) {
    return '/onboarding/current-needs';
  }
  
  if (!profile.currentBenefits || !profile.currentBenefits.length) {
    return '/onboarding/benefits';
  }
  
  // All steps are complete
  return '/home';
};
